// Must match `HOSTED_FORM_CAPTCHA_ACTIONS` and `modules/captcha` `CAPTCHA_ACTIONS` in pbp-api exactly.
export const CAPTCHA_ACTIONS = {
  validationSubmission: 'validation_submission',
  validationSubmissionDocument: 'validation_submission_document',
  login: 'login',
  forgotPassword: 'forgot_password',
} as const

export type CaptchaAction = typeof CAPTCHA_ACTIONS[keyof typeof CAPTCHA_ACTIONS]
